import { Injectable, OnDestroy } from '@angular/core';
import { Analytics, logEvent, setUserId, setUserProperties, setDefaultEventParameters } from '@angular/fire/analytics';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';

import { AnalyticsEvent, User } from '@shared/models';

import { CookieConsentService } from './cookie-consent.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService implements OnDestroy {
  private enabled = false;
  private sub?: Subscription;

  constructor(
    private router: Router,
    private analytics: Analytics,
    private cookieService: CookieConsentService
  ) {
    this.sub = this.cookieService.isCategoryEnabled$('analytics').subscribe((enabled) => (this.enabled = enabled));

    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
      if (!this.enabled) return;
      logEvent(analytics, AnalyticsEvent.PageView, {
        page_location: window.location.href,
        page_path: e.urlAfterRedirects,
        page_title: document?.title,
      });
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  setUser(user: User) {
    if (!this.enabled) return;

    try {
      setUserId(this.analytics, user.id);

      const defaultProperties = { email: user.email, app_type: 'web' };
      setUserProperties(this.analytics, defaultProperties);
      setDefaultEventParameters(defaultProperties);
    } catch (error) {
      console.error(error);
    }
  }

  logEvent(
    eventName: string,
    eventParams?: {
      [key: string]: unknown;
    }
  ) {
    if (!this.enabled) return;
    logEvent(this.analytics, eventName, eventParams);
  }
}
